import { Task } from '../types/interfaces';

import { TaskClosingCodesTemplate } from './TaskClosingCodesTemplate';

export const TaskTemplate: Task = {
  id: 0,
  externalId: '',
  name: '',
  selectedAction: { id: '', label: '' },
  taskType: { key: '', label: '' },
  asset: { key: '', label: '' },
  taskStatus: 'Новый',
  department: {
    key: '',
    label: '',
    children: []
  },
  employees: [],
  creationDate: '',
  actualStartDate: '',
  plannedStartDate: '',
  plannedEndDate: '',
  actualEndDate: '',
  priority: '',
  description: '',
  isClosed: false,
  possibleStatusTransitions: [],
  actualOperations: [],
  plannedOperations: [{ key: '', label: '' }],
  attachments: [],
  closeCode: TaskClosingCodesTemplate,
  lastStatusTransitionId: undefined,
  hasAttachments: true
};
